import { 
    Record,
    Map 
} from "immutable";
import moment from "moment";

export class BusinessProgramRecord extends Record({
    id: null,
    company: null,
    program_type: null,
    product_lines: null,
    is_business_program_qualification_detail: false,
    is_business_program_cashback: false,
    is_business_program_facility_detail: false,
    is_business_program_fee: false,
    is_business_program_interest: false,
    is_business_program_recourse_detail: false
}) {}

export class BusinessProductRecord extends Record({
    id: null,
    name: null,
    short_name: null,
    code: null,
    anchor_type: null,
    seller_type: null,
    buyer_type: null
}) {}

export class BuyerQualificationDetailRecord extends Record({
    id: null,
    min_vintage_with_anchor_in_months: null,
    min_vintage_with_seller_in_months: null,
    is_pat_positive: null,
    pat_positive_years: null,
    overdue_instances_allowed: null,
    overdue_instances_allowed_ageing_in_days: null,
    minimum_dependence_on_seller_perc: null,
    minimum_dependence_on_anchor_perc: null,
    min_cibil_score: null
}){}

export class BusinessProgramCashbackRecord extends Record({
    id: null,
    buyer_share: null,
    seller_share: null
}) {}

export class BusinessProgramFacilityDetailRecord extends Record({
    id: null,
    due_date_from_type: null,
    disbursal_wait_days: null,
    max_tenor: null,
    grace_period_days: null,
    hold_back_percentage: null,
    interest_subvention_percentage: null,
    product_lines: new Map({})
}){}

export class BusinessProgramFeeRecord extends Record({
    id: null,
    fee_type: null,
    limit_range_start: null,
    limit_range_end: null,
    fee_calculation_type: null,
    amount_or_percentage: null,
    fee_debit_at: null
}) {}

export class BusinessProgramInterestRecord extends Record({
    id: null,
    from_days: null,
    to_days: null,
    rate_of_interest: null,
    interest_type: null,
    interest_definition_type: null
}) {}

export class BusinessProgramRecourseDetailRecord extends Record({
    id: null,
    account_block_days: null,
    cheque_bank_days: null,
    hold_back_amount_use_days: null,
    overdue_settlement_notice_days: null,
    stock_take_back_days: null,
    stop_billing_days: null
}){}

export class ProgramCompanyRecord extends Record({
    id: null,
    name: null,
    short_name: null,
    gstin: null
}){}

export class ProductCategoryRecord extends Record({
    id: null,
    name: null,
    short_name: null
}) {}

export class ProductLineDetailRecord extends Record({
    id: null,
    name: null,
    short_name: null,

}){}

export class ProductLineRecord extends Record({
    id: null,
    product_category: new ProductCategoryRecord(),
    product_line: new ProductLineDetailRecord()
}) {}

export class AgreementDetailRecord extends Record({
    id: null,
    signing_date: null,
    start_date: null,
    end_date: null
}){
    get agreement_details() {
        return new Map({})
            .set("id", this.id)
            .set("signing_date", this.signing_date ? moment(this.signing_date) : null)
            .set("start_date", this.start_date ? moment(this.start_date) : null)
            .set("end_date", this.end_date ? moment(this.end_date) : null);
    }
}

export class BusinessProgramAttachments extends Record({
    id: null,
    buyer_finance_agreements: null,
    create_date: null,
    credit_note: null,
    guarantor_agreement: null,
    name_clearance: null
}){}

export class BusinessBasicDetailRecord extends Record({
    id: null,
    program_size: null,
    limit_max: null,
    min_limit: null,
    is_higher_limit_allowed: null,
    relationship_termination_notice_days: null,
    facility_name: null,
    can_buyer_raise_rff: null,
    can_seller_raise_rff: null, 
}){}

export class BusinessProgramDetailRecord extends Record({
    id: null,
    business_program_display_name: null,
    company: new ProgramCompanyRecord(),
    business_product: new BusinessProductRecord(),
    program_type: null,
    parent_program: null,
    business_program_basic_details: new BusinessBasicDetailRecord(),
    program_size: null,
    limit_max: null,
    is_higher_limit_allowed: null,
    relationship_termination_notice_days: null,
    facility_name: null,
    can_buyer_raise_rff: null,
    can_seller_raise_rff: null,
    business_program_buyer_qualification_detail: new BuyerQualificationDetailRecord(),
    business_program_cashback: new BusinessProgramCashbackRecord(),
    business_program_facility_details: new Map({}),
    business_program_fee: new Map({}),
    business_program_interest: new Map({}),
    business_program_recourse_detail: new BusinessProgramRecourseDetailRecord(),
    business_program_agreement_details: new AgreementDetailRecord(),
    business_program_attachments: new BusinessProgramAttachments()
}){
    get businessProgramDetails() {
        return new Map({})
            .set("id", this.id)
            .set("company", this.company)
            .set("program_type", this.program_type)
            .set("business_product", this.business_product)
            .set("parent_program", this.parent_program)
            .set("program_size", this.program_size)
            .set("limit_max", this.limit_max)
            .set("min_limit", this.min_limit)
            .set("is_higher_limit_allowed", this.is_higher_limit_allowed)
            .set("relationship_termination_notice_days", this.relationship_termination_notice_days)
            .set("facility_name", this.facility_name)
            .set("can_buyer_raise_rff", this.can_buyer_raise_rff)
            .set("can_seller_raise_rff", this.can_seller_raise_rff);
    }

    get basicDetails() {
        return this.business_program_basic_details;
    }

    get buyerQualificationDetails() {
        return this.business_program_buyer_qualification_detail;
    }

    get businessInterestDetails() {
        return this.business_program_interest;
    }

    get businessProgramFee() {
        return this.business_program_fee;
    }

    get businessFacilityDetails() {
        return this.business_program_facility_details;
    }

    get businessProgramRecourseDetails() {
        return this.business_program_recourse_detail;
    }

    get businessProgramCashbackDetails() {
        return this.business_program_cashback;
    }

    get businessAgreementDetails() {
        return this.business_program_agreement_details;
    }

    get businessAttachments() {
        return this.business_program_attachments;
    }
}